<template>
  <div id="app">
    <link href="https://fonts.googleapis.com/css?family=Muli:400,600&display=swap" rel="stylesheet">
    <HelloWorld/>
  </div>
</template>
<script>
import HelloWorld from './components/HelloWorld.vue';

export default {
  name: 'app',
  components: {
    HelloWorld,
  },
};
</script>

<style lang="scss">
html {
  color: white;
  background-color: #75ac97;
  font-family: 'Muli', sans-serif;

}
#app {
  font-family: 'Muli', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  padding: 30px;
}
a {
  color: white;
}

.owl-theme .owl-nav [class*='owl-'] {
  color: #75ac97;
  font-weight: 700;
  background: white;
}

.owl-theme .owl-dots .owl-dot span {
  background: white!important;
}
</style>
